import React from'react';
import { useNavigate, useLocation } from'react-router-dom';

const BottomTabBar = ({ activeTab, onTabChange }) => {
 const navigate = useNavigate();
 const location = useLocation();
 const tabs = [
 { id:'home', label:'Home', icon:'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6'},
 { id:'rides', label:'Rides', icon:'M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z'},
 { id:'profile', label:'Profile', icon:'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z'},
 { id:'account', label:'Account', icon:'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z'}
 ];

 const handleTabClick = (tabId) => {
 // Use routing for profile and rides
 switch (tabId) {
 case'profile':
 navigate('/profile');
 break;
 case'rides':
 navigate('/rides');
 break;
 case'home':
 // Call onTabChange to update activeTab state, then navigate
 onTabChange?.(tabId);
 navigate('/dashboard');
 break;
 case'account':
 // Keep in-dashboard tab switching, and pass explicit route state
 // when entering from any other screen so Account opens directly.
 onTabChange?.(tabId);
 if (location.pathname !=='/dashboard') {
 navigate('/dashboard', { state: { activeTab:'account'} });
 }
 break;
 default:
 onTabChange?.(tabId);
 break;
 }
 };

 // Determine active tab based on current route
 const getActiveTab = () => {
 if (location.pathname ==='/profile') return'profile';
 if (location.pathname ==='/rides') return'rides';
 if (location.pathname ==='/dashboard') {
 return activeTab ==='account'?'account':'home';
 }
 return activeTab;
 };

 const currentActiveTab = getActiveTab();

 return (
 <div
 className="bottom-tabbar fixed inset-x-0 bottom-0 z-[100] bg-transparent px-2 pl-safe pr-safe pb-[max(env(safe-area-inset-bottom),10px)] xs:px-3 lg:hidden">
 <div
 className="mx-auto flex max-w-screen-sm items-center justify-between gap-1 rounded-[26px] border border-[#d6ebe5] bg-[linear-gradient(180deg,rgba(255,255,255,0.96)_0%,rgba(242,255,250,0.92)_100%)] p-1.5 shadow-[0_20px_40px_-26px_rgba(15,118,110,0.55)] backdrop-blur-xl xs:gap-2 xs:p-2">
 {tabs.map((tab) => (
 <button
 key={tab.id}
 onClick={() => handleTabClick(tab.id)}
 aria-label={tab.label}
 aria-current={currentActiveTab === tab.id ?'page': undefined}
 className={`touch-target flex min-w-0 flex-1 flex-col items-center justify-center rounded-2xl px-1.5 py-1.5 transition-all duration-300 xs:px-3 xs:py-2 ${
 currentActiveTab === tab.id
 ?'bg-[linear-gradient(135deg,#0f766e_0%,#065f46_100%)] text-white shadow-[0_16px_30px_-20px_rgba(15,118,110,0.95)]':'text-slate-600 hover:bg-white/70'}`}
 >
 <svg
 className={`mb-0.5 h-5 w-5 xs:mb-1 xs:h-6 xs:w-6 ${
 currentActiveTab === tab.id ?'text-white':'text-slate-500'}`}
 fill="none"stroke="currentColor"viewBox="0 0 24 24"aria-hidden="true">
 <path
 strokeLinecap="round"strokeLinejoin="round"strokeWidth={2}
 d={tab.icon}
 />
 </svg>
 <span
 className={`truncate text-[10px] font-medium xs:text-xs ${
 currentActiveTab !== tab.id ?'text-slate-600':''}`}
 >
 {tab.label}
 </span>
 </button>
 ))}
 </div>
 </div>
 );
};

export default BottomTabBar;
